import React, { useState, useEffect } from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'
import ibsStore from '../Stores/IbsSurveyStore'
import { saveValueNew, getPageErrorsCtrl, secretValidateCtrl } from "../../control"
import {  SurveyTypeURL } from "../../Enums/constants";
import { setSurveyResponseValue, getSurveyResponseValue } from "../../Helpers/General/SurveyResponsesHelper";


const AssetTabConfiguratorModal = observer((props) => {
    let [doneBtnStatus, setDoneDisabledStatus] = useState(false);
    useEffect(() => {
    }, [doneBtnStatus])

    const saveAndCloseModal = () => {
        ibsStore.showAssetConfigureModal = false;

    }
    const closeModal = () => {
        ibsStore.showAssetConfigureModal = false;
    }
   
    const changeIsMandateLevel = (e) => {
        let currVal = getSurveyResponseValue("IsMandateLevel");
        if (e.target.value != currVal) {
            setSurveyResponseValue("IsMandateLevel", e.target.value);
            saveValueNew("IsMandateLevel", e.target.value, {});
            ibsStore.showCustomiseTableOpts = false;
            ibsStore.showCustomiseTableOpts2 = true;
            setSurveyResponseValue("IsAvgAssetsGiv", null);
            saveValueNew("IsAvgAssetsGiv", null, {});
            setDoneDisabledStatus(true);
        }
       
    }

    const checkAvg = () => {
        let val = getSurveyResponseValue("IsAvgAssetsGiv")
       
        if (val == 1) {
            return true;

        } else {
            return false;
        }
    }
    const checkYearEnd = () => {
        let val = getSurveyResponseValue("IsAvgAssetsGiv")
        if (val == 1 || val === "" || val === true) {
            return false;

        } else {
            return true;
        }
    }
 
    const checkMissingFields = () => {
        let valAvg = getSurveyResponseValue("IsAvgAssetsGiv")
        let valMandateLevel = getSurveyResponseValue("IsMandateLevel")
        if (valAvg === "" || valMandateLevel === "") return true
        else return false
        


    }

    const changeIsAvgAssetsGiv = async (e) => {
        setSurveyResponseValue("IsAvgAssetsGiv", e.target.value); 
        saveValueNew("IsAvgAssetsGiv", e.target.value, {});
        setDoneDisabledStatus(false);
        store.allValidationErrorsList[store.currentLandedPage] = [];
        await secretValidateCtrl();
        await getPageErrorsCtrl(store.currentLandedPage);
    }
    const showHideSection1 = () => {
        ibsStore.showCustomiseTableOpts = !ibsStore.showCustomiseTableOpts;

    }
    const showHideSection2 = () => {
        if (ibsStore.checkMandateLevel==null) {
            alert("Choose your reporting basis first!")
        } else {
            ibsStore.showCustomiseTableOpts2 = !ibsStore.showCustomiseTableOpts2;
        }
       

    }
    const checkToShow = () => {
        if (store.surveyTypeUrl == SurveyTypeURL.DB && window.location.href.includes("Assets") && ibsStore.checkMandateLevel == null && ibsStore.showAssetConfigureModal !== false) {
            //ibsStore.showAssetConfigureModal = true
            ibsStore.showAssetConfigureModal = true;
        }
        if (ibsStore.showAssetConfigureModal) {
            return true;
        } else {
            return false;
        }
    }

    const checkAssetsFilled = () => {
        if (ibsStore.checkMandateLevel != 0) return false
        let index = ibsStore.allTableResponses["combinedAssets"].findIndex(element => element.CostBaseFeesThousands != null || element.CostPerformanceThousands != null || element.CostThousands != null || element.HoldingsMillions != null
            || element.InternalMonitoringCost != null || element.UnderlyingFundFees != null || element.UnderlyingPerfFees != null || element.FeesPaidHoldingsMillions != null);

        if (index == -1 ) return false
        return true
    }
    

    return (
        <React.Fragment>
            <section className="generalModal">

                <Modal
                    visible={checkToShow()}
                    effect="fadeInDown"
                    onClickAway={closeModal}
                    width="950"
                    className="testClass"

                >

                    <div className="commentModal">
                     
                        <h3> <i className=""></i> Customize your table</h3>
                        <hr />
                        <h5 className="addrow-heading" onClick={showHideSection1}><i className={`${(ibsStore.checkMandateLevel==null || ibsStore.showCustomiseTableOpts) ? "fas fa-angle-down" : "fas fa-angle-right"}`} style={{ paddingRight: '10px' }}></i>
                            Choose your reporting basis</h5>
                        <div className={(ibsStore.checkMandateLevel == null || ibsStore.showCustomiseTableOpts) ? 'fade-in' : 'fade-out'}>
                            <div className="row assetConfig" hidden={checkAssetsFilled()}>
                                <div className="col-md-11">
                                    <h6>I want to provide data by mandates. <i>(recommended)</i><br /><i className="subtext" >I want to provide mandate-level data for all asset classes.</i></h6>
                                </div>
                                <div className="col-md-1">
                                    <input type="radio" id="mandate" name="fav_language" value="1" checked={ibsStore.checkMandateLevel == 1} onClick={event => changeIsMandateLevel(event)}></input>
                                    <label for="mandate"></label>

                                </div>

                            </div>
                            <div className="row assetConfig" hidden={ibsStore.hasMandateData}>
                                <div className="col-md-11">
                                    <h6>I want to provide data by asset class.<br /><i className="subtext">I want to continue to provide data by the traditional CEM view of asset class aggregates.</i> </h6>
                                </div>
                                <div className="col-md-1">

                                    <input type="radio" id="assets" name="fav_language" value="0" checked={ibsStore.checkMandateLevel == 0} onClick={event => changeIsMandateLevel(event)}></input> <label for="assets"></label>

                                </div>
                            </div>
                            <div className="row assetConfig" hidden={checkAssetsFilled()}>
                                <div className="col-md-11">
                                    <h6>I want to provide data by asset class and mandates.<br /><i className="subtext">I want to provide data partially by aggregates for some asset classes and partially by mandates for other asset classes.
                                        <br />Or/and <br />
                                        I want the ability to overwrite the asset class returns estimated from mandates by a number that matches our internal calculation.</i></h6>

                                </div>
                                <div className="col-md-1">
                                    <input className="radioBtn" type="radio" id="combined" name="fav_language" value="2" checked={ibsStore.checkMandateLevel == 2} onClick={event => changeIsMandateLevel(event)}></input>
                                    <label for="combined"></label>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <h5 className="addrow-heading" onClick={showHideSection2}><i className={`${ibsStore.showCustomiseTableOpts2 ? "fas fa-angle-down" : "fas fa-angle-right"}`} style={{ paddingRight: '10px' }}></i>
                            Choose your NAV basis</h5>
                        <div className={ibsStore.showCustomiseTableOpts2  ? 'fade-in' : 'fade-out'}>

                        <div className="row assetConfig">
                            <div className="col-md-11">
                                    <h6>I want to provide average net asset values (NAVs).</h6>
                                    {ibsStore.checkMandateLevel !=0 &&
                                        <i className="subtext">We only accept average holdings on this reporting basis. If you want to provide year-end holdings, please report by asset classes.</i>
                                    }
                                    </div>
                                <div className="col-md-1">

                                    <input type="radio" id="test" name="fav_languag2" value="1" onChange={async (event) => await changeIsAvgAssetsGiv(event)} checked={checkAvg()} ></input>
                                <label for="test"></label>
                        </div>
                        </div>
                            <div className="row" hidden={ibsStore.checkMandateLevel>0}>
                                <div className="col-md-11">
                                <h6> I want to provide year-end net asset values (NAVs).</h6>
                                </div>

                                <div className="col-md-1">

                                    <input type="radio" id="test1" name="fav_languag2" value="0" onChange={async(event) => await changeIsAvgAssetsGiv(event)} checked={checkYearEnd()}></input>
                                    <label for="test1"></label>
                                </div>
                            </div>
                      
                        </div>
                        <div className="row">
                            <div className="subtext" hidden={!ibsStore.hasMandateData}>
                                <span style={{ color: "red" }}><i>Clear out all the mandates if you want to provide year-end holdings by the traditional CEM asset class view, or contact us.</i></span>
                            </div>
                            <div className="subtext" hidden={!checkAssetsFilled()}>
                                <span style={{ color: "red" }}><i>Clear out all the asset class level data if you want to switch to reporting mandates.</i></span>
                            </div>
                        </div>
                        <button type="button" className="btn btn-close" onClick={saveAndCloseModal} disabled={doneBtnStatus || checkMissingFields()}>Done</button>
                        <button type="button" className="btn btn-close grey" onClick={closeModal}>Cancel</button>
                    </div>


                     
                </Modal>
            </section>
        </React.Fragment>
    );

});

export default AssetTabConfiguratorModal;

//<SurveyElement labelText="Do you want to enter your holdings, returns and costs by asset class/style (CEM's traditional view) or by manager mandate?" name="IsMandateLevel" inputType={ElementType.SELECT} options={SelectCombos.ALL_SOME} />

//<button type="button" className="btn btn-close grey" onClick={closeModal}>Cancel</button>
